import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './auth/AuthContext';
import { PreferencesProvider } from './preferences/PreferencesContext';
import { I18nProvider } from './i18n/I18nContext';
import { applyThemeClass, readTheme } from './preferences/preferencesStorage';

// Apply theme before paint to avoid flash
applyThemeClass(readTheme());

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

const root = ReactDOM.createRoot(rootEl);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <PreferencesProvider>
        <I18nProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </I18nProvider>
      </PreferencesProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();


